import { render, staticRenderFns } from "./PurposeDimensions.vue?vue&type=template&id=9f29f25e&scoped=true"
import script from "./PurposeDimensions.vue?vue&type=script&lang=js"
export * from "./PurposeDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f29f25e",
  null
  
)

export default component.exports